import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  standalone: true,
  name: 'apiUrl'
})
export class ApiUrlPipe implements PipeTransform {
  public transform(url: string, scaleTo?: number): string {
    const token = localStorage.getItem('JWT_TOKEN');
    let result = `${environment.url}/${url}?token=${token}`;
    if (scaleTo) {
      result += `&scaleTo=${scaleTo}`;
    }
    return result;
  }
}
